import { validator } from "@/utils/validator";

export const companySpecificBusinessClassificationSchema = validator.object().shape({
  companySpecificBusinessClassificationName: validator.string().trim().emptyToNull().label("区分").required(),
});

export const masterDataCreateCompanySpecificIndustrySchema = validator.object().shape({
  companySpecificIndustry: validator.string().trim().emptyToNull().label("分野").required(),
  companySpecificBusinessClassifications: validator
    .array()
    .of(companySpecificBusinessClassificationSchema)
    .label("companySpecificBusinessClassifications")
    .required(),
});

export const masterDataUpdateCompanySpecificIndustrySchema = validator.object().shape({
  companySpecificIndustry: validator.string().trim().emptyToNull().label("分野").required(),
});
